import { ComponentProps, useState, useEffect } from 'react';
import styled from 'styled-components';
import { BackTop } from '@yj-intl/riff-react';
import { transition } from '../../../../../common/css/setting/variable';

interface Props {
  /** 下方向に追加でオフセットが必要な場合に追加で必要になるオフセットの高さを指定する */
  readonly additionalBottomOffsetPx?: number;
}

const ToTopButton = styled(({ isShow, ...componentProps }: { isShow: boolean } & ComponentProps<typeof BackTop>) => (
  <BackTop {...componentProps} />
))`
  ${({ isShow }) => (isShow ? `visibility: visible;` : 'opacity:0; visibility: hidden;')}
  transition: ${transition.backToButton_sp};
`;

const ScrollTopButtonWithFadeIn: React.FC<Props> = ({ additionalBottomOffsetPx }) => {
  const [isShow, setShow] = useState(false);

  useEffect(() => {
    window.addEventListener(
      'scroll',
      () => {
        // スクロールの現在位置が一画面分より下なら上に戻るボタンボタンを表示
        if (window.pageYOffset > window.innerHeight) {
          setShow(true);
        } else {
          setShow(false);
        }
      },
      // スクロールジャンク対策初回表示時をなめらかにするため入れておく
      {
        passive: true
      }
    );
  }, []);

  // setTimeoutを使いアニメーション風なスクロールをする(0.5秒)
  const smoothScrollToTop = () => {
    const scrollHeight = window.scrollY / 5;
    smoothScroll(scrollHeight);
  };

  const smoothScroll = (scrollHeight: number) => {
    setTimeout(() => {
      window.scrollTo(window.scrollX, window.scrollY - scrollHeight);
      // 到達していなければ再帰的にスクロール
      if (window.scrollY > 0) {
        smoothScroll(scrollHeight);
      }
    }, 100);
  };

  return (
    <ToTopButton
      onClick={() => smoothScrollToTop()}
      isShow={isShow}
      // デフォルトだとwindow右端から8pxの位置になるため微調整する
      style={{
        right: 20,
        bottom: additionalBottomOffsetPx === undefined ? 30 : additionalBottomOffsetPx + 30
      }}
      data-cl-params="_cl_vmodule:pagetop;_cl_link:pagetop;"
    />
  );
};

export default ScrollTopButtonWithFadeIn;
